/**
 * 会員登録フロー種別（signup_flow）の判定ロジック。
 *
 * 行動の記録は snippets/signup-flow-tracker.liquid が全ページで行う（キー名を揃えること）。
 * - cart   : セッション中にカートページへ到達した
 * - view   : セッション中に商品詳細ページを表示した
 * - direct : 上記いずれにも該当しない
 * 上から順に評価し、最初に該当したものを採用する。
 */

export const SIGNUP_FLOW_VIEWED_ITEM_KEY = 'kd_signup_viewed_item';
export const SIGNUP_FLOW_REACHED_CART_KEY = 'kd_signup_reached_cart';
export const SIGNUP_FLOW_SUBMITTED_KEY = 'kd_signup_submitted';
export const SIGNUP_FLOW_FIELD_ID = 'customer-note-signup-flow';

export const SIGNUP_FLOW_VALUES = ['cart', 'view', 'direct'] as const;
export type SignupFlow = (typeof SIGNUP_FLOW_VALUES)[number];

function readMarker(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function determineSignupFlow(): SignupFlow {
  if (readMarker(SIGNUP_FLOW_REACHED_CART_KEY)) return 'cart';
  if (readMarker(SIGNUP_FLOW_VIEWED_ITEM_KEY)) return 'view';
  return 'direct';
}

export function markSignupSubmitted(): void {
  try {
    sessionStorage.setItem(SIGNUP_FLOW_SUBMITTED_KEY, '1');
  } catch {
    /* noop */
  }
}

export function hasSignupSubmitted(): boolean {
  return readMarker(SIGNUP_FLOW_SUBMITTED_KEY);
}

export function clearSignupFlowMarkers(): void {
  try {
    sessionStorage.removeItem(SIGNUP_FLOW_REACHED_CART_KEY);
    sessionStorage.removeItem(SIGNUP_FLOW_VIEWED_ITEM_KEY);
    sessionStorage.removeItem(SIGNUP_FLOW_SUBMITTED_KEY);
  } catch {
    /* noop */
  }
}
